<main>
  <loading-overlay [isLoading]="isLoading() > 0" />
  <p-toast position="top-center" />

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <div>
          <h1>{{ 'COA_Title' | translateWF: 'Chart of Accounts' }}</h1>
        </div>
        <div class="page__title_buttons">
          <p-button [label]="'Export' | translateWF: 'Export'" icon="pi pi-download" variant="outlined" (click)="export()" />
          <p-button [label]="'COA_NewAccount' | translateWF: 'New account'" icon="pi pi-plus" (click)="openCreate()" />
        </div>
      </div>
    </div>

    <div class="toolbar">
      <span class="p-input-icon-left search">
        <i class="pi pi-search"></i>
        <input
          pInputText
          [value]="searchTerm()"
          (input)="onSearch($any($event.target).value)"
          [placeholder]="'COA_Search' | translateWF: 'Search account number or name'"
          class="w-full"
        />
      </span>
      <div class="chips">
        @for (chip of typeChips; track chip.label) {
          <p-button
            [label]="chip.label"
            size="small"
            [severity]="typeFilter() === chip.value ? 'primary' : 'secondary'"
            [text]="typeFilter() !== chip.value"
            (click)="setType(chip.value)"
          />
        }
      </div>
      <span class="count">{{ matchCount() }} {{ 'COA_Accounts' | translateWF: 'accounts' }}</span>
    </div>

    <p-treetable [value]="treeNodes()" [rowHover]="true">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'COA_Account' | translateWF: 'Account' }}</th>
          <th style="width: 12rem">{{ 'COA_Type' | translateWF: 'Type' }}</th>
          <th class="text-right" style="width: 16rem">{{ 'COA_Balance' | translateWF: 'Balance' }} · {{ currency() }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
        <tr [ttRow]="rowNode">
          <td>
            <p-treeTableToggler [rowNode]="rowNode" />
            <span class="font-mono account-no" [class.font-semibold]="rowData.isGroup">{{ rowData.accountNumber }}</span>
            @if (rowData.isReconciliation) {
              <a class="cs-table-link" (click)="openSubledger(rowData)">{{ rowData.name }}</a>
              <p-tag severity="secondary" [value]="'COA_Reconciliation' | translateWF: 'Reconciliation a/c'" styleClass="cs-tag-inline" />
            } @else {
              <span [class.font-semibold]="rowData.isGroup">{{ rowData.name }}</span>
            }
            <button
              type="button"
              class="add-child"
              (click)="openEdit(rowData); $event.stopPropagation()"
              [title]="'COA_EditAccount_Row' | translateWF: 'Edit name and who may post here'"
            >
              <i class="pi pi-pencil"></i>
            </button>
            <button
              type="button"
              class="add-child"
              (click)="openCreate(rowData); $event.stopPropagation()"
              [title]="'COA_NewAccount_AddChild' | translateWF: 'Add account under this one'"
            >
              <i class="pi pi-plus"></i>
            </button>
          </td>
          <td class="text-muted">{{ rowData.typeLabel }}</td>
          <td class="text-right tabular-nums" [class.font-semibold]="rowData.isGroup">
            @if (rowData.balance === null) {
              <span class="balance--masked" [pTooltip]="'COA_BalanceHidden' | translateWF: 'You do not have permission to view this balance'">{{
                rowData.balance | maskedAmount
              }}</span>
            } @else {
              {{ rowData.balance | maskedAmount }} {{ currency() }}
            }
            @if (rowData.isReconciliation) {
              <i class="pi pi-angle-right open-chevron" (click)="openSubledger(rowData)"></i>
            }
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="3" class="text-center text-muted py-6">{{ 'COA_Empty' | translateWF: 'No accounts found.' }}</td>
        </tr>
      </ng-template>
    </p-treetable>
  </div>
</main>
